export default __webpack_public_path__ + "static/media/21.921a89e8.jpg";